module.exports = __webpack_public_path__ + "static/media/logofonasa1.9e84f052.svg";